<template>
  <div>
    <v-card
      outlined
      style="height: 30vh;max-height: 30vh;overflow-y: scroll;"
    >
      <template
        v-for="final_disposal in manifestFinalDisposals"
      >
        <v-card-text
          v-if="!final_disposal._destroy"
          :key="final_disposal.key"
        >
          <v-row dense>
            <v-col
              cols="12"
              md="5"
            >
              <cs-date-picker
                :date.sync="final_disposal.final_disposal_date"
                :minimum-date="manifest.collected_date ? manifest.collected_date : null"
                :maximum-date="systemDate"
                @dateChangedCallback="(date) => { final_disposal.final_disposal_date = date }"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="`final_disposal_date-${final_disposal.key}`"
                    class="requiredMark"
                    name="最終処分終了日"
                    rules="required"
                  >
                    <v-text-field
                      v-model="final_disposal.final_disposal_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="最終処分終了日"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      readonly
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>

              <validation-provider
                v-if="false"
                v-slot="{ errors }"
                :vid="`final_disposal_date-${final_disposal.key}`"
                class="requiredMark"
                name="最終処分終了日"
                rules="required"
              >
                <vue-ctk-date-time-picker
                  v-model="final_disposal.final_disposal_date"
                  :min-date="manifest.collected_date ? manifest.collected_date : null"
                  :max-date="systemDate"
                  auto-close
                  no-value-to-custom-elem
                  only-date
                  no-button
                  no-header
                  color="#0070B3"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  position="bottom"
                >
                  <v-text-field
                    v-model="final_disposal.final_disposal_date"
                    :error-messages="errors"
                    append-icon="mdi-calendar"
                    clearable
                    dense
                    hide-details="auto"
                    label="最終処分終了日"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    readonly
                  />
                </vue-ctk-date-time-picker>
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="5"
            >
              <validation-provider
                v-slot="{ errors }"
                :vid="`final_disposal_site_id-${final_disposal.key}`"
                class="requiredMark"
                name="最終処分事業場"
                rules="required"
              >
                <v-autocomplete
                  v-model="final_disposal.final_disposal_site_id"
                  :items="finalDisposalSites"
                  :error-messages="errors"
                  dense
                  label="最終処分事業場"
                  hide-details="auto"
                  outlined
                  clearable
                  persistent-placeholder
                  style="font-size: 80%"
                >
                  <template v-slot:selection="{ item }">
                    {{ item.text }}
                  </template>
                  <template v-slot:item="{ item }">
                    <div>
                      <div>{{ item.text }}</div>
                      <small class="text--disabled">{{ item.address }}</small>
                    </div>
                  </template>
                </v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="text-right"
            >
              <v-btn
                :disabled="disableRemoveButton"
                class="error"
                small
                @click="removeButtonClickEvent(final_disposal)"
              >
                削除
              </v-btn>
            </v-col>
          </v-row>
          <v-divider class="mt-2" />
        </v-card-text>
      </template>
    </v-card>
    <br />
    <v-row dense>
      <v-col cols="12" class="text-right">
        <v-btn
          class="primary"
          small
          @click="addButtonClickEvent"
        >
          追加
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'FinalDisposalReportForm',
  components: {},
  mixins: [],
  props: {
    manifest: {
      type: Object,
      default: () => null,
    },
    manifestFinalDisposals: {
      type: Array,
      default: () => [],
    },
    finalDisposalSites: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      systemDate: this.$dayjs().format("YYYY-MM-DD"),
    }
  },
  computed: {
    disableRemoveButton () {
      const validItems = this.manifestFinalDisposals.filter( v => !v._destroy)
      return validItems.length <= 1
    }
  },
  watch: {},
  created() {
  },
  methods: {
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.$emit('addButtonCallback', this.manifest.id)
    },
    /**
     * 削除ボタン クリックイベント
     * @param item
     */
    removeButtonClickEvent (item) {
      this.$emit('removeButtonCallback', this.manifest.id, item)
    },

  }
}
</script>
